<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_backoutRequestStatus') || '状态'"
            >
              <el-checkbox-group v-model="form.listBackoutRequestStatus">
                <el-checkbox label="S">
                  {{ $l('form_label_backoutRequestStatus_S') || '已提交' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_backoutRequestStatus_Y') || '已审核' }}
                </el-checkbox>
                <el-checkbox label="R">
                  {{ $l('form_label_backoutRequestStatus_R') || '已驳回' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgBulkOrderNo') || '大货订单编号'"
            >
              <el-input
                v-model.trim="form.evgBulkOrderNo"
                :placeholder="
                  $l('form_placeholder_evgBulkOrderNo') || '请输入大货订单编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_custOrderNo') || '客户订单编号'"
            >
              <el-input
                v-model.trim="form.custOrderNo"
                :placeholder="
                  $l('form_placeholder_custOrderNo') || '请输入客户订单编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_outBillType') || '出单类型'">
              <dict-select
                v-model="form.listOutBillType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'outBillType' }"
                :placeholder="
                  $l('form_placeholder_outBillType') || '请选择出单类型'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPerson') || '业务'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_salesPerson') || '请选择业务'
                "
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_merchandiser') || '跟单'">
              <dict-select
                v-model="form.listMerchandiserCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_merchandiser') || '请选择跟单'
                "
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_platform') || '渠道'">
              <dict-select
                v-model="form.listPlatformCode"
                url="/ecom/evg/platform/select"
                :placeholder="$l('form_placeholder_platform') || '请选择渠道'"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '客户'">
              <dict-select
                v-model="form.custCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_cust') || '请选择客户'"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_orderDate') || '订单日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.orderDateStart"
                    :placeholder="
                      $l('form_placeholder_orderDateStart') || '请选择订单日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.orderDateEnd"
                    :placeholder="
                      $l('form_placeholder_orderDateEnd') || '请选择订单日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_deliveryDate') || '交货日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    :placeholder="
                      $l('form_placeholder_deliveryDateStart') ||
                        '请选择交货日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    :placeholder="
                      $l('form_placeholder_deliveryDateEnd') || '请选择交货日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_shippingDate') || '发运日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShippingDate"
                    :placeholder="
                      $l('form_placeholder_beginShippingDate') ||
                        '请选择发运日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShippingDate"
                    :placeholder="
                      $l('form_placeholder_endShippingDate') || '请选择发运日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderWh') || '收货仓库'">
              <el-input
                v-model.trim="form.orderWh"
                :placeholder="
                  $l('form_placeholder_orderWh') || '请输入收货仓库'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_region') || '货物运抵国'">
              <dict-select
                v-model="form.listRegionCode"
                :body="{ dictType: 'region' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_placeholder_region') || '请选择货物运抵国'
                "
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_dispatchPort') || '出运港口'">
              <dict-select
                v-model="form.listDispatchPort"
                url="/master/port/select"
                :placeholder="
                  $l('form_placeholder_dispatchPort') || '请选择出运港口'
                "
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listBackoutRequestStatus: ['S'] }
export default {
  data() {
    return { advqueryDialogVisible: false, form: { ...initForm } }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
